// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"TablePollAssignButton_buttonWrapper__O+xVH","assignButton":"TablePollAssignButton_assignButton__nCcdh"};